// ObiHub OS üst çubuğunun gerçek verisi: bağlantı durumu (/integrations, mevcut kenar/üst çubukla aynı kaynak) ve
// mevcut üst çubuğun (components/layout/Header.js) topladığı sipariş bildirimleri: aynı localStorage kaydı, aynı
// "kapatıldı" listesi ve aynı "silinmiş entegrasyon" süzmesi; canlı güncelleme "obihub:new-orders" olayıyla. Uydurma veri yok.
import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const PROVIDER = { trendyol: "Trendyol", hepsiburada: "Hepsiburada", hepsijet: "HepsiJet", parasut: "Paraşüt", bizimhesap: "BizimHesap", benimpos: "BenimPOS", woocommerce: "WooCommerce", "turkcell-efatura": "Turkcell e-Fatura", n11: "N11", amazon: "Amazon", ikas: "ikas", shopify: "Shopify" };
const okStatus = (s) => ["success", "connected"].includes(String(s || "").trim().toLowerCase());
const live = (rows) => (Array.isArray(rows) ? rows : []).filter((r) => String(r?.status || "").trim().toLowerCase() !== "deleted");

export function integrationStatus(rows, link) {
  const items = live(rows).map((r, i) => {
    const prov = String(r?.provider || "").trim().toLowerCase();
    return { key: String(r?.id || `${prov}-${i}`), name: r?.name || PROVIDER[prov] || r?.provider || "Entegrasyon", ok: okStatus(r?.status) };
  }).sort((a, b) => Number(a.ok) - Number(b.ok));
  return { healthy: items.filter((i) => i.ok).length, total: items.length, items, to: link("/panel/entegrasyonlar") };
}

const scopeOf = (user) => {
  let fallback = "";
  try { fallback = localStorage.getItem("obihub_active_user_id") || ""; } catch (e) { /* yok */ }
  return String(user?.id || fallback || "anon").trim() || "anon";
};
const readJson = (k) => { try { const v = JSON.parse(localStorage.getItem(k) || "[]"); return Array.isArray(v) ? v : []; } catch (e) { return []; } };
const keyOf = (n) => n?.id_key || `${n?.integration_id}:${n?.channel_order_id}:${n?.status}`;
const money = (v, cur) => `${Number(v || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${!cur || cur === "TRY" ? "₺" : cur}`;

export function useTopbarData(enabled, user, link) {
  const [rows, setRows] = useState(null);
  const [orders, setOrders] = useState([]);
  const scope = scopeOf(user);
  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    Promise.resolve().then(() => api.get("/integrations")).then((r) => { if (!cancelled) setRows(Array.isArray(r) ? r : []); }).catch(() => {});
    setOrders(readJson(`obihub_order_notifications:${scope}`));
    const onNew = (e) => { const list = e?.detail?.notifications; setOrders(Array.isArray(list) ? list : readJson(`obihub_order_notifications:${scope}`)); };
    window.addEventListener("obihub:new-orders", onNew);
    return () => { cancelled = true; window.removeEventListener("obihub:new-orders", onNew); };
  }, [enabled, scope]);

  return useMemo(() => {
    const dismissed = new Set(readJson(`obihub_dismissed_order_notifications:${scope}`));
    const ids = new Set(live(rows).map((r) => String(r?.id || "")).filter(Boolean));
    const seen = new Set();
    const visible = (enabled ? orders : []).filter((n) => {
      const k = keyOf(n);
      if (dismissed.has(k) || seen.has(k)) return false;
      seen.add(k);
      if (n?.integration_id && ids.size && !ids.has(String(n.integration_id))) return false;
      return true;
    });
    return {
      status: rows ? integrationStatus(rows, link) : null,
      notifications: { count: visible.length, items: visible.slice(0, 10).map((n) => ({
        key: keyOf(n), title: `Yeni sipariş · ${n?.channel_order_id || "—"}`,
        message: `${n?.customer_name || "Müşteri"} · ${money(n?.total_amount, n?.currency)}`, to: n?.route || link("/panel/entegrasyonlar"),
      })) },
    };
  }, [rows, orders, scope, enabled]); // eslint-disable-line react-hooks/exhaustive-deps
}
